import { render, staticRenderFns } from "./mechanical-engineering-3.vue?vue&type=template&id=2f670700&"
import script from "./mechanical-engineering-3.vue?vue&type=script&lang=js&"
export * from "./mechanical-engineering-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports